import { jsx as _jsx } from "react/jsx-runtime";
const sizeClasses = {
    sm: "h-4 w-4 border-2",
    md: "h-6 w-6 border-2",
    lg: "h-8 w-8 border-3",
};
export function Spinner({ className = "", size = "md" }) {
    return (_jsx("div", { className: [
            "inline-block animate-spin rounded-full border-current border-t-transparent text-[var(--color-muted-foreground)]",
            sizeClasses[size],
            className,
        ].join(" "), role: "status", "aria-label": "loading" }));
}
